import { Model, Attr, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { ShortTermRate, Lot } from './';

@Model()
export default class ShortTermDay extends ApplicationRecord {
  static jsonapiType = 'short-term-days';

  static async listHeaders() {
    const headers: Array<{
      text: string;
      value: string;
      align?: 'start' | 'center' | 'end';
      sortable?: boolean;
      filterable?: boolean;
      groupable?: boolean;
      divider?: boolean;
      class?: string | string[];
      width?: string | number;
      filter?: (value: any, search: string, item: any) => boolean;
      sort?: (a: any, b: any) => number;
    }> = [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Days',
        value: 'days',
      },
    ];

    try {
      const lots = (await Lot.order('name').all()).data;
      lots.forEach((lot, index) => {
        const header = {
          text: lot.name + ' Price',
          value: `sortedRates[${index}].formattedRate`,
          sortable: false,
        };
        headers.push(header);
      });
    } catch (error) {
      // Error
    }

    return headers;
  }

  static scopeFactory() {
    return ShortTermDay.includes(['shortTermRates.lot']);
  }

  static defaultOptions() {
    return {
      sortBy: ['days'],
    };
  }

  @Attr() days: number;

  @HasMany() shortTermRates: ShortTermRate[];

  get sortedRates() {
    const sortedRates = this.shortTermRates.slice().sort((a, b) => {
      if (a.lot.name > b.lot.name) {
        return 1;
      }
      if (a.lot.name < b.lot.name) {
        return -1;
      }
      return 0;
    });
    return sortedRates;
  }

  get formattedDays() {
    const pluralise = (
      count: string | number,
      noun: string,
      suffix: string = 's',
    ) => `${count} ${noun}${count !== 1 ? suffix : ''}`;

    return pluralise(this.days, 'day');
  }
}
